<template>
  <cx-padding
    :paddingTypeFlag.sync="paddingType"
    :padding.sync="padding"
    :paddingTop.sync="paddingTop"
    :paddingRight.sync="paddingRight"
    :paddingBottom.sync="paddingBottom"
    :paddingLeft.sync="paddingLeft"
  />
</template>

<script>
import { historyCombineWrap } from "utils/revork"
export default {
  props: {
    options: {
      type: Object
    },
    ids: {
      type: Object
    }
  },
  data() {
    return {
      offsetWdith: 0
    }
  },
  mounted() {
    this.getWidth()
  },
  computed: {
    padding: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "padding", "padding", 0)
      },
      set(newVal) {
        historyCombineWrap(() => {
          this.$emit("update", "padding", newVal)
          this.$emit("update", "paddingTop", newVal)
          this.$emit("update", "paddingLeft", newVal)
          this.$emit("update", "paddingRight", newVal)
          this.$emit("update", "paddingBottom", newVal)
        })()
      }
    },
    paddingType: {
      get() {
        return this.options.paddingType === "global" || this.options.paddingType === 1 ? 1 : 2
      },
      set(newVal) {
        if (newVal === this.paddingType) return
        this.$emit("update", "paddingType", newVal)
      }
    },
    paddingEdge: {
      get() {
        const data = this.options //获取数据
        const dataMap = ["paddingTop", "paddingLeft", "paddingRight", "paddingBottom"] //过滤工具数组
        return (
          data &&
          parseInt(
            dataMap.reduce((prevK, currK, currKIndex) => {
              if (currKIndex - 1 === 0) {
                return Number(data[prevK]) + Number(data[currK])
              } else {
                return prevK + Number(data[currK])
              }
            }) / dataMap.length
          )
        )
      },
      set(newVal) {
        historyCombineWrap(() => {
          if (newVal === this.paddingEdge) return
          const padding = {
            paddingTop: Number(newVal),
            paddingLeft: Number(newVal),
            paddingRight: Number(newVal),
            paddingBottom: Number(newVal)
          }
          Object.keys(padding).forEach(k => {
            this.$emit("update", k, padding[k])
          })
        })()
      }
    },
    paddingLeft: {
      get() {
        return this.hasProperty(this.options, "paddingLeft")
      },
      set(newVal) {
        if (newVal === this.paddingLeft) return
        this.$emit("update", "paddingLeft", newVal)
      }
    },
    paddingTop: {
      get() {
        return this.hasProperty(this.options, "paddingTop")
      },
      set(newVal) {
        if (newVal === this.paddingTop) return
        this.$emit("update", "paddingTop", newVal)
      }
    },
    paddingRight: {
      get() {
        return this.hasProperty(this.options, "paddingRight")
      },
      set(newVal) {
        if (newVal === this.paddingRight) return
        this.$emit("update", "paddingRight", newVal)
      }
    },
    paddingBottom: {
      get() {
        return this.hasProperty(this.options, "paddingBottom")
      },
      set(newVal) {
        if (newVal === this.paddingBottom) return
        this.$emit("update", "paddingBottom", newVal)
      }
    }
  },
  methods: {
    getWidth() {
      requestAnimationFrame(() => {
        const width = this.$el.offsetWidth
        if (!!width) {
          this.offsetWdith = width
        } else {
          this.getWidth()
        }
      })
    }
  }
}
</script>

<style scoped>
.clearFloat {
  clear: both;
}
</style>
